<template>
  <div :class="classes">
    <pt-page-title title="订金结算" :isSearch="true" @search="search" @emptySearch="emptySearch" :keyword="keyword"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <template v-if="isExport">
      <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
      <!-- <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button> -->
      <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
      </template>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-deposit-settlement-table ref="table" :paramsData="paramsData">
      <template>
        <el-table-column label="入库状态">
          <template slot-scope="scope">
            {{scope.row.hasRecord}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope" v-if="hasConfirmRecord && scope.row.hasOperation">
            <el-button type="text" @click="confirmRecord(scope.row)">确认入库</el-button>
          </template>
        </el-table-column>
      </template>
    </pt-deposit-settlement-table>
  </div>
</template>

<script>
// 组件class前缀
import { filterLabels } from './deposit-settlement'
import ptDepositSettlementTable from './pt-deposit-settlement-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-deposit-settlement'
// 权限
const PERM_LOCAL_FINANCIAL_STAFF = 'PERM_LOCAL_FINANCIAL_STAFF'
export default {
  name: 'pt-deposit-settlement',
  components: {
    ptDepositSettlementTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    hasConfirmRecord () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_LOCAL_FINANCIAL_STAFF)
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    areaList: {
      type: Array,
      default: function () {
        return []
      }
    },
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filterLabels: filterLabels,
      params: {},
      paramsData: {},
      isExport: true,
      keyword: ''
    }
  },
  watch: {
    areaList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'addressCode') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    companyList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'organizationId') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    search (val) {
      this.keyword = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'keyword', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'keyword')
    },
    initTimeSlot (val, name) {
      let date = new Date(new Date().toLocaleDateString()).getTime()
      this.$route.query.endDate = date + 24 * 60 * 60 * 1000 - 1
      this.$route.query.startDate = date - 30 * 24 * 3600 * 1000
    },
    // 确认已入库
    confirmRecord (val) {
      this.$confirm('您是否确认入库', '订金结算', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.getConfirmRecord(val)
      })
    },
    // 确认已入库
    getConfirmRecord (val) {
      let data = {
        id: val.id,
        orderAuditStatus: 'RECORDED'
      }
      this.$store.dispatch('confirmRecord', data).then(res => {
        val.hasRecord = '已入库'
        this.paramsData = { ...this.paramsData }
        this.$message.success('已入库成功')
      }).catch(err => {
        this.$message.error(err || '确认已入库失败')
      })
    },
    filter () {
      let params = { ...this.params }
      for (var key in params) {
        if (key === 'orderDate') {
          params = { ...params, ...params.orderDate }
          this.$delete(params, 'orderDate')
          this.$delete(params, 'index')
        }
        if (key === 'addressCodes') {
          let addressCode = params.addressCodes.districtGbCode || params.addressCodes.cityGbCode || params.addressCodes.provinceGbCode || ''
          params.addressCode = addressCode
          this.$delete(params, 'addressCodes')
        }
      }
      this.paramsData = { ...params }
      for (var key2 in this.paramsData) {
        if (!this.paramsData[key2]) {
          this.$delete(this.paramsData, key2)
        }
      }
    },
    // 导出
    exportOldToNewAudit () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in params) {
            if (key === 'orderDate') {
              params = { ...params, ...params.orderDate }
              this.$delete(params, 'orderDate')
              this.$delete(params, 'index')
            }
            if (key === 'addressCodes') {
              let addressCode = params.addressCodes.districtGbCode || params.addressCodes.cityGbCode || params.addressCodes.provinceGbCode || ''
              params.addressCode = addressCode
              this.$delete(params, 'addressCodes')
            }
          }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          this.$emit('depositSettlementListExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 导出历史
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/deposit_settlement/?name=deposit_audit_export')
    },
    cleanParams () {
      this.params = {}
      emptyObject(this.params)
      this.filter()
    }
  },
  created () {
    this.initTimeSlot()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
